import { labelFromOptions } from '@helpers/OptionHelper'

// Public: Allows to obtain the label for a value from a list options.
export default labelFromOptions
